var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loadingProfiles } },
    [
      _c(
        "div",
        [
          _c("b-card", [
            _c("div", { staticClass: "row justify-content-between" }, [
              _c("div", { staticClass: "col-6" }, [
                _c("h4", { staticClass: "text-primary mb-10" }, [
                  _vm._v(" Gestión de perfiles de acceso para usuarios ")
                ])
              ]),
              _c("div", { staticClass: "col-6 text-right" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Agregar perfil",
                        expression: "'Agregar perfil'"
                      },
                      {
                        name: "has-permission",
                        rawName: "v-has-permission",
                        value: "WAP100",
                        expression: "'WAP100'"
                      }
                    ],
                    staticClass: "btn btn-primary",
                    attrs: { "data-cy": "add-profile" },
                    on: {
                      click: function($event) {
                        return _vm.addProfile()
                      }
                    }
                  },
                  [_c("feather-icon", { attrs: { icon: "PlusIcon" } })],
                  1
                ),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Descargar",
                        expression: "'Descargar'"
                      },
                      {
                        name: "has-permission",
                        rawName: "v-has-permission",
                        value: "WAP107",
                        expression: "'WAP107'"
                      }
                    ],
                    staticClass: "ml-2 btn btn-secondary",
                    attrs: { "data-cy": "download-profiles" },
                    on: {
                      click: function($event) {
                        return _vm.reportProfile(true)
                      }
                    }
                  },
                  [_c("feather-icon", { attrs: { icon: "DownloadIcon" } })],
                  1
                )
              ])
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "ul",
                  { staticClass: "list-group mt-5" },
                  _vm._l(_vm.companyProfiles, function(profile) {
                    return _c(
                      "li",
                      {
                        key: "profile-" + profile.idPerfil,
                        staticClass: "list-group-item",
                        attrs: { id: "profile-" + profile.idPerfil }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "actions cursor-pointer" },
                          [
                            _c("feather-icon", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Bitácora",
                                  expression: "'Bitácora'"
                                },
                                {
                                  name: "has-permission",
                                  rawName: "v-has-permission",
                                  value: "WAP105",
                                  expression: "'WAP105'"
                                }
                              ],
                              staticClass: "icon mr-2",
                              attrs: {
                                size: "18",
                                icon: "ListIcon",
                                "data-cy": "binnacle"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getBinnacleProfile(profile)
                                }
                              }
                            }),
                            _c("feather-icon", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value:
                                    "Migrar perfil a otro ambiente desde " +
                                    _vm.environment,
                                  expression:
                                    "`Migrar perfil a otro ambiente desde ${environment}`"
                                },
                                {
                                  name: "has-permission",
                                  rawName: "v-has-permission",
                                  value: "WAP104",
                                  expression: "'WAP104'"
                                }
                              ],
                              staticClass: "icon mr-2",
                              attrs: {
                                size: "18",
                                icon: "SendIcon",
                                "data-cy": "migrate-profile"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.migrateProfile(profile)
                                }
                              }
                            }),
                            _c("feather-icon", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Usuarios asociados a perfil",
                                  expression: "'Usuarios asociados a perfil'"
                                },
                                {
                                  name: "has-permission",
                                  rawName: "v-has-permission",
                                  value: "WAP106",
                                  expression: "'WAP106'"
                                }
                              ],
                              staticClass: "icon mr-2",
                              attrs: {
                                size: "18",
                                icon: "UsersIcon",
                                "data-cy": "get-users-profile"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getUsersProfile(profile)
                                }
                              }
                            }),
                            _c("feather-icon", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Modificar perfil",
                                  expression: "'Modificar perfil'"
                                },
                                {
                                  name: "has-permission",
                                  rawName: "v-has-permission",
                                  value: "WAP101",
                                  expression: "'WAP101'"
                                }
                              ],
                              staticClass: "icon mr-2",
                              attrs: {
                                size: "18",
                                icon: "EditIcon",
                                color: "green",
                                "data-cy": "edit-profile-info"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.editProfileInfo(profile)
                                }
                              }
                            }),
                            _c("feather-icon", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Agregar roles",
                                  expression: "'Agregar roles'"
                                },
                                {
                                  name: "has-permission",
                                  rawName: "v-has-permission",
                                  value: "WAP103",
                                  expression: "'WAP103'"
                                }
                              ],
                              staticClass: "icon mr-2",
                              attrs: {
                                size: "18",
                                icon: "KeyIcon",
                                "data-cy": "get-profile-info"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getProfileInfo(profile)
                                }
                              }
                            }),
                            _c("feather-icon", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Eliminar perfil",
                                  expression: "'Eliminar perfil'"
                                },
                                {
                                  name: "has-permission",
                                  rawName: "v-has-permission",
                                  value: "WAP102",
                                  expression: "'WAP102'"
                                }
                              ],
                              staticClass: "icon",
                              attrs: {
                                size: "18",
                                icon: "TrashIcon",
                                color: "red",
                                "data-cy": "delete-profile"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeProfile(profile)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-8 col-12" }, [
                            _c("b", [_vm._v("Nombre: ")]),
                            _vm._v(" " + _vm._s(profile.nombre) + " ")
                          ]),
                          _c("div", { staticClass: "col-md-8 col-12 mt-2" }, [
                            _c("div", { staticClass: "about pr-3" }, [
                              _c("b", [_vm._v("Descripción: ")]),
                              _vm._v(" " + _vm._s(profile.descripcion) + " ")
                            ])
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "profileRoles",
          attrs: {
            size: "xl",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Roles del perfil " + _vm.profile.nombre
          }
        },
        [
          _c("b-overlay", { attrs: { show: _vm.loadingRoles } }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center justify-content-end" },
              [
                _c("b-form-input", {
                  staticClass: "d-inline-block mr-1",
                  attrs: {
                    placeholder: "Filtrar...",
                    "data-cy": "search-vacant-role"
                  },
                  model: {
                    value: _vm.searchInVacantRoles,
                    callback: function($$v) {
                      _vm.searchInVacantRoles = $$v
                    },
                    expression: "searchInVacantRoles"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "row mt-3 px-2" }, [
              _c(
                "div",
                {
                  staticClass: "col-6",
                  staticStyle: { height: "500px", overflow: "scroll" }
                },
                _vm._l(Object.values(_vm.filteredAvailableRoles), function(
                  role
                ) {
                  return _c(
                    "div",
                    { key: role.id, staticClass: "row mt-2 mb-2" },
                    [
                      _c("div", { staticClass: "col-8 profile p-4" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(role.nombre))
                        ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-4 text-left mt-4" },
                        [
                          !_vm.profileRoles[role.id]
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "mr-1",
                                  attrs: { size: "sm", variant: "success" },
                                  on: {
                                    "~click": function($event) {
                                      return _vm.addRoleToProfile(role)
                                    }
                                  }
                                },
                                [_vm._v(" agregar ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass: "col-6",
                  staticStyle: { height: "500px", overflow: "scroll" }
                },
                _vm._l(Object.values(_vm.profileRoles), function(role) {
                  return _c(
                    "div",
                    { key: role.rolId, staticClass: "row mt-2 mb-2" },
                    [
                      _c("div", { staticClass: "col-8 profile p-4" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(role.nombre))
                        ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-4 text-left mt-4" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-1",
                              attrs: { size: "sm", variant: "warning" },
                              on: {
                                "~click": function($event) {
                                  return _vm.removeRoleToProfile(role)
                                }
                              }
                            },
                            [_vm._v(" remover ")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "addProfile",
          attrs: {
            size: "md",
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Perfil de acceso"
          }
        },
        [
          _c("div", { staticClass: "row mt-3" }, [
            _c(
              "form",
              { staticClass: "w-100", attrs: { "data-vv-scope": "profile" } },
              [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Nombre del perfil" } },
                      [
                        _c("b-form-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|max:255",
                              expression: "'required|max:255'"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            name: "name",
                            "data-vv-as": "Nombre del perfil",
                            state:
                              !_vm.errors.has("profile.name") &&
                              _vm.newProfile.name !== ""
                          },
                          model: {
                            value: _vm.newProfile.name,
                            callback: function($$v) {
                              _vm.$set(_vm.newProfile, "name", $$v)
                            },
                            expression: "newProfile.name"
                          }
                        }),
                        _c("FormError", {
                          attrs: {
                            attributeName: "profile.name",
                            errorsForm: _vm.errors
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Descripción del perfil" } },
                      [
                        _c("b-form-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|max:255",
                              expression: "'required|max:255'"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            label: "Descripción del perfil",
                            name: "description",
                            "data-vv-as": "Descripción del perfil",
                            state:
                              !_vm.errors.has("profile.description") &&
                              _vm.newProfile.description !== ""
                          },
                          model: {
                            value: _vm.newProfile.description,
                            callback: function($$v) {
                              _vm.$set(_vm.newProfile, "description", $$v)
                            },
                            expression: "newProfile.description"
                          }
                        }),
                        _c("FormError", {
                          attrs: {
                            attributeName: "profile.description",
                            errorsForm: _vm.errors
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              !_vm.editMood
                ? _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: {
                        variant: "primary",
                        disabled: _vm.loadingProfiles
                      },
                      on: {
                        "~click": function($event) {
                          return _vm.addNewProfile()
                        }
                      }
                    },
                    [_vm._v(" Agregar ")]
                  )
                : _vm._e(),
              _vm.editMood
                ? _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: {
                        variant: "primary",
                        disabled: _vm.loadingProfiles,
                        "data-cy": "update-profile"
                      },
                      on: {
                        "~click": function($event) {
                          return _vm.editProfile()
                        }
                      }
                    },
                    [_vm._v(" Editar ")]
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _c(
        "b-modal",
        {
          ref: "migrate-profile-modal",
          attrs: {
            "hide-footer": "",
            "no-close-on-backdrop": "",
            title: "Migrar perfil " + _vm.profile.nombre
          }
        },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.isMigratingProfile } },
            [
              _c("v-select", {
                attrs: {
                  multiple: "",
                  label: "title",
                  options: _vm.avalaibleEnvironments
                },
                model: {
                  value: _vm.targetEnvironment,
                  callback: function($$v) {
                    _vm.targetEnvironment = $$v
                  },
                  expression: "targetEnvironment"
                }
              }),
              _c(
                "div",
                { staticClass: "text-center mt-3" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: { variant: "primary" },
                      on: {
                        "~click": function($event) {
                          return _vm.migrateProfileToTargetEnvironments()
                        }
                      }
                    },
                    [_vm._v(" Migrar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "profileUsers",
          attrs: {
            "hide-footer": "",
            "no-close-on-backdrop": "",
            size: "lg",
            title: "Usuarios asociados a perfil " + _vm.profile.nombre
          }
        },
        [
          _c("b-overlay", { attrs: { show: _vm.loadingRoles } }, [
            !_vm.usersProfile.length
              ? _c("div", { staticClass: "text-center my-1" }, [
                  _vm._v(" No se encontraron usuarios asociados a este perfil ")
                ])
              : _vm._e(),
            !!_vm.usersProfile.length
              ? _c(
                  "div",
                  {
                    staticClass: "wrap-table",
                    staticStyle: {
                      width: "100%",
                      height: "300px",
                      overflow: "hidden",
                      "overflow-y": "scroll"
                    }
                  },
                  [
                    _c(
                      "table",
                      {
                        staticClass: "table-users stripe",
                        attrs: { "aria-description": "table-users" }
                      },
                      [
                        _c("th", [_vm._v("Nombre")]),
                        _c("th", [_vm._v("Correo")]),
                        _vm._l(_vm.usersProfile, function(user, indextr) {
                          return _c(
                            "tr",
                            {
                              key: indextr,
                              attrs: { "data-cy": "users-profile" }
                            },
                            [
                              _c(
                                "td",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: user.nombre,
                                      expression: "user.nombre"
                                    }
                                  ],
                                  staticClass: "text-truncate"
                                },
                                [
                                  _c("span", { staticClass: "d-flex" }, [
                                    _c("img", {
                                      key: "onlineImg",
                                      staticClass:
                                        "rounded-full shadow-md cursor-pointer",
                                      attrs: {
                                        src: _vm.userAvatar(user.avatar),
                                        alt: "user-img",
                                        width: "40",
                                        height: "40"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "ml-3",
                                        staticStyle: { "line-height": "40px" }
                                      },
                                      [_vm._v(" " + _vm._s(user.nombre) + " ")]
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "td",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: user.correo,
                                      expression: "user.correo"
                                    }
                                  ],
                                  staticClass: "text-truncate"
                                },
                                [_vm._v(" " + _vm._s(user.correo) + " ")]
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "binnacleProfile",
          attrs: {
            size: "lg",
            "hide-footer": "",
            title: "Bitácora del perfil " + _vm.profile.nombre
          }
        },
        [
          _c("binnacle-user", {
            attrs: { user: _vm.profile, "binnacle-user": _vm.binnacleProfile },
            on: { "close-action": _vm.closeModal }
          })
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "modalReport",
          attrs: { title: "Descargar reporte de perfiles", "hide-footer": "" },
          on: { hidden: _vm.resetModalReport }
        },
        [
          _c("b-overlay", { attrs: { show: _vm.loadingParamsProfile } }, [
            _c("strong", [_vm._v("Seleccione los parámetros para el reporte")]),
            _c(
              "div",
              { staticClass: "mt-4 row justify-content-between" },
              _vm._l(_vm.optionsReportProfile, function(option) {
                return _c(
                  "div",
                  { key: option.key, staticClass: "col-6" },
                  [
                    _c("b-form-group", {
                      attrs: { label: "Categoría " + option.nombre },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var ariaDescribedby = ref.ariaDescribedby
                              return [
                                _c("b-form-checkbox-group", {
                                  attrs: {
                                    options: option.campos,
                                    "aria-describedby": ariaDescribedby,
                                    switches: "",
                                    stacked: "",
                                    "value-field": "key",
                                    "text-field": "nombre"
                                  },
                                  model: {
                                    value: _vm.selectedParams,
                                    callback: function($$v) {
                                      _vm.selectedParams = $$v
                                    },
                                    expression: "selectedParams"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.reportProfile(false)
                      }
                    }
                  },
                  [_vm._v(" Enviar ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }